<template>
  <div id="contenedor-cargando-informacion-intranet">
    <div id="cargando-informacion" class="d-flex justify-content-center align-items-center">
       <div id="seccion-principal" class="d-flex flex-wrap justify-content-center align-items-center">
        <div class="d-flex flex-wrap align-items-center justify-content-center">
          <figure class="text-center mb-5 mx-5">
            <img src="../../../assets/logo-pj-transparente-blanco.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
          </figure>
          <div class="w-100 mb-5 justify-content-center text-center position-relative d-flex">
            <i v-if="!error" id="seccion-cargando" class="fas fa-circle-notch fa-spin fa-5x" style="left: 0; right: 0"></i>
            <div v-if="error" class="seccion-error form-inline">
              <h2><i class="fas fa-exclamation-triangle mt-4 ml-4"></i>&nbsp;PAGINA DE INTRANET EN MANTENIMIENTO</h2>
            </div>
          </div>
        </div>
      </div>   
    </div>
  </div>
</template>
<script>
export default {
  props: {
    mostrarError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    error() {
      return this.mostrarError;
    }
  }
}
</script>
<style scoped>
  .seccion-error {
    background-color: rgb(29, 29, 29);
    padding: 2em 0em 1em 3em;
    border: 1px solid rgb(17, 17, 17);
  }

  .seccion-error h2 {
    color: white;
    font-weight: bold;
  }

  .seccion-error i {
    color: yellow
  }
  #contenedor-cargando-informacion-intranet {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 100 !important;
      visibility: visible;
      opacity: 1;
      transition: visibility 1s, opacity 1s;
  }

  .cerrarCargaDePaginaWeb {
    visibility: hidden !important;
    opacity: 0 !important;
  }

  #cargando-informacion {
    background: rgba(34,34,34,1);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100 !important
  }

    #cargando-informacion > #seccion-principal > div {
      width: 460px;
      height: 600px;
      align-content: center;
      margin-top: -5vh;
    }

    #cargando-informacion img {
      margin-top: -5vh;
      width: 100%;
    }

    #cargando-informacion > #seccion-principal {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,.5);
    }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-top: 3vh;
  }

  h4 {
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 2vh;
  }

  i {
    color: #FFFFFF;
    position: absolute;
    top: 10px;
    left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Intranet/Comun/CCargandoInformacion.vue